// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file realtime_event/realtime_event_requests.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { MessageKey } from '../message/message_model_pb';
import { file_message_message_model } from '../message/message_model_pb';

/**
 * Describes the file realtime_event/realtime_event_requests.proto.
 */
export const file_realtime_event_realtime_event_requests: GenFile =
  /*@__PURE__*/
  fileDesc(
    'CixyZWFsdGltZV9ldmVudC9yZWFsdGltZV9ldmVudF9yZXF1ZXN0cy5wcm90bxIUY29tLmdlbS5iZmYuY29udHJhY3QiIAoeUmVhbHRpbWVFdmVudHNTdWJzY3JpYmVSZXF1ZXN0ImEKKFJlYWx0aW1lU3Vic2NyaWJlT25NZXNzYWdlc1VwZGF0ZVJlcXVlc3QSNQoLbWVzc2FnZUtleXMYASADKAsyIC5jb20uZ2VtLmJmZi5jb250cmFjdC5NZXNzYWdlS2V5IioKGFVzZXJUeXBpbmdNZXNzYWdlUmVxdWVzdBIOCgZjaGF0SWQYASABKANCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z',
    [file_message_message_model]
  );

/**
 * @generated from message com.gem.bff.contract.RealtimeEventsSubscribeRequest
 */
export type RealtimeEventsSubscribeRequest =
  Message<'com.gem.bff.contract.RealtimeEventsSubscribeRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.RealtimeEventsSubscribeRequest.
 * Use `create(RealtimeEventsSubscribeRequestSchema)` to create a new message.
 */
export const RealtimeEventsSubscribeRequestSchema: GenMessage<RealtimeEventsSubscribeRequest> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event_requests, 0);

/**
 * @generated from message com.gem.bff.contract.RealtimeSubscribeOnMessagesUpdateRequest
 */
export type RealtimeSubscribeOnMessagesUpdateRequest =
  Message<'com.gem.bff.contract.RealtimeSubscribeOnMessagesUpdateRequest'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.MessageKey messageKeys = 1;
     */
    messageKeys: MessageKey[];
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeSubscribeOnMessagesUpdateRequest.
 * Use `create(RealtimeSubscribeOnMessagesUpdateRequestSchema)` to create a new message.
 */
export const RealtimeSubscribeOnMessagesUpdateRequestSchema: GenMessage<RealtimeSubscribeOnMessagesUpdateRequest> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event_requests, 1);

/**
 * @generated from message com.gem.bff.contract.UserTypingMessageRequest
 */
export type UserTypingMessageRequest = Message<'com.gem.bff.contract.UserTypingMessageRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.UserTypingMessageRequest.
 * Use `create(UserTypingMessageRequestSchema)` to create a new message.
 */
export const UserTypingMessageRequestSchema: GenMessage<UserTypingMessageRequest> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event_requests, 2);
